import React, { useEffect, useRef, useState } from "react";
import { DateRange } from "react-date-range";
import datepipeModel from "../../../models/datepipemodel";
import { useSelector } from "react-redux";
import "./style.scss";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { TiArrowSortedDown } from "react-icons/ti";
import { Tooltip } from "react-tooltip";
import { IoIosArrowDown } from "react-icons/io";
import moment from "moment";
import methodModel from "../../../methods/methods";

const DateRangePicker = ({
  value,
  isEffectiveEndDate = false,
  onChange,
  disabled = false,
  placeholder = "",
  isCompare = false,
  fullWidth = true,
  showcustom = true,
  title = '',
  buttonShow = false,
  monthsCount = 2,
  disbaledDate = false,
  customButtons = false,
  maxDate = null,
  allTime = false,
  outerClass = '',
  allTimeText = 'All Time',
  isFocusedData
}) => {
  const user = useSelector((state) => state.user);
  const [toggle, setToggle] = useState(false);
  const [CustomSelct, setCustomSelect] = useState(false)
  const [ItemsOpen, setItemsOpen] = useState(false);
  const [range, setRange] = useState(localStorage.getItem('selectRange'));

  const rangeList = customButtons
    ? [
      { id: "15 Days", name: "15 Days" },
      { id: "30 Days", name: "30 Days" },
      { id: "45 Days", name: "45 Days" },
      { id: "90 Days", name: "90 Days" },
    ]
    : disbaledDate
      ? [
        { id: "This Month", name: "This Month" },
        { id: "This Year", name: "This Year" },
      ]
      : [
        { id: "This Month", name: "This Month" },
        { id: "This Year", name: "This Year" },
        { id: "Last Month", name: "Last Month" },
        { id: "Last Year", name: "Last Year" },
      ];

  if (allTime) {
    rangeList.push({ id: "all", name: allTimeText });
  }

  const compareList = [
    { id: "", name: "Reset Compare" },
    { id: "Previous Period", name: "Previous Period" },
    { id: "Previous Year(Same Date)", name: "Previous Year(Same Date)" },
  ];

  const ref = useRef();
  const menuButtonRef = useRef();

  const blockDateChange = (e, close) => {
    setRange('custom')
    localStorage.setItem('selectRange', 'custom')
    onChange({ ...value, ...e, compare: "" });

    if (
      (datepipeModel.datetostring(e.startDate) !=
      datepipeModel.datetostring(e.endDate))
    ) {
      setToggle(false);
    }
    if (String(e.startDate) != String(e.endDate)) {
      setItemsOpen(false);
      // Focus the MenuButton after date selection
      setTimeout(() => {
        if (menuButtonRef.current) {
          menuButtonRef.current.focus();
        }
      }, 100);
    }
  };

  const toggleChange = () => {
    setToggle(!toggle);

  };

const getBlockValue = () => {
  try {
const parseDateString = (dateString) => {
  if (!dateString) return new Date();

  const [year, month, day] = dateString?.split('T')[0]?.split('-')?.map(Number);

  if (
    isNaN(year) ||
    isNaN(month) ||
    isNaN(day)
  ) {
    try{
    const parsed = moment(dateString, moment.ISO_8601,true).format('YYYY-MM-DD'); // strict ISO 8601 parsing
     if(!parsed.isValid()){
      return new Date()
     }else{
      return parsed;
     }
    }catch{
    return new Date(); // fallback if the date is malformed
    }
  }

  return new Date(year, month - 1, day);
};
  let v = {
     startDate: value["startDate"] ? parseDateString(value["startDate"]) : new Date(),
      endDate: value["endDate"] ? parseDateString(value["endDate"]) : new Date(),
      key: "selection",
    };

    return [v];
  } catch {
    return [{
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    }];
  }
};

  // Custom date formatter function
  function formatDateToString(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const rangeClick = (e) => {
    let startDate = "";
    let endDate = "";
    localStorage.setItem('selectRange', e);

    if (customButtons) {
      if (e === 'custom') {
        return;
      }
      const days = parseInt(e.split(' ')[0], 10);
      const today = new Date();
      startDate = formatDateToString(today);
      const end = new Date(today);
      end.setDate(today.getDate() + days);
      endDate = formatDateToString(end);
    } else {
      if (e === "Last Month") {
        const current = new Date();
        const year = current.getFullYear();
        const month = current.getMonth();
        const lastMonthStart = new Date(year, month - 1, 1);
        const lastMonthEnd = new Date(year, month, 0);

        startDate = formatDateToString(lastMonthStart);
        endDate = formatDateToString(lastMonthEnd);
      } else if (e === "This Month") {
        const current = new Date();
        const currentStr = formatDateToString(current);

        if (disbaledDate) {
          // Use today's date in the current month and year
          startDate = `${currentStr.split("-")[0]}-${currentStr.split("-")[1]}-${String(current.getDate()).padStart(2, '0')}`;
        } else {
          // Start of the month
          startDate = `${currentStr.split("-")[0]}-${currentStr.split("-")[1]}-01`;
        }

        const monthEnd = new Date(current.getFullYear(), current.getMonth() + 1, 0);
        endDate = formatDateToString(monthEnd);
      } else if (e === "This Year") {
        const current = new Date();
        const currentStr = formatDateToString(current);

        if (disbaledDate) {
          startDate = `${currentStr.split("-")[0]}-${String(current.getMonth() + 1).padStart(2, '0')}-${String(current.getDate()).padStart(2, '0')}`;
        } else {
          startDate = `${current.getFullYear()}-01-01`;
        }

        // December 31st of this year
        const yearEnd = new Date(current.getFullYear(), 11, 31);
        endDate = formatDateToString(yearEnd);
      } else if (e === "Last Year") {
        const current = new Date();
        const lastYear = current.getFullYear() - 1;

        startDate = `${lastYear}-01-01`;
        const lastYearEnd = new Date(lastYear, 11, 31);
        endDate = formatDateToString(lastYearEnd);
      } else if (e === 'all') {
        startDate = '';
        endDate = '';
        setToggle(false);
      }
    }

    setRange(e);
    if (!(e === 'custom' && !startDate && !endDate)) {
      setItemsOpen(false);
      console.log(startDate, endDate, "THis is the Date------");
      onChange({ ...value, startDate, endDate, compare: "" });
      setTimeout(() => {
        if (menuButtonRef.current) {
          menuButtonRef.current.focus();
        }
      }, 100);
    }

    if (e !== "") {
      setToggle(false);
    }
  };


  const getDays = (s, e) => {
    const startDate = new Date(s);
    const endDate = new Date(e);
    const timeDifference = endDate - startDate;
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    return daysDifference;
  };

  function getEffectiveEndDate(endDate) {
    const currentDate = new Date();
    const parsedEndDate = new Date(endDate);
    const effectiveDate = parsedEndDate > currentDate ? currentDate : parsedEndDate;
    const year = effectiveDate.getFullYear();
    const month = String(effectiveDate.getMonth() + 1).padStart(2, '0');
    const day = String(effectiveDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const previousYear = () => {
    let start = "";
    let end = "";
    if (value.startDate && value.endDate) {
      let ssplit = value.startDate.split("-");
      let esplit = value.endDate.split("-");
      if (isEffectiveEndDate) {
        esplit = getEffectiveEndDate(value.endDate).split("-");
      }
      let year = Number(ssplit[0]);
      let eyear = Number(esplit[0]);

      let d = new Date(`${year - 1}-${ssplit[1]}-${ssplit[2]}`);
      start = datepipeModel.datetostring(d);

      let ed = new Date(`${eyear - 1}-${esplit[1]}-${esplit[2]}`);
      end = datepipeModel.datetostring(ed);
    }
    return { start, end };
  };

  function getMonthDifference(date1, date2) {
    const year1 = date1.getFullYear();
    const month1 = date1.getMonth();
    const year2 = date2.getFullYear();
    const month2 = date2.getMonth();
    return ((year2 - year1) * 12 + (month2 - month1)) + 1
  }

  const previousMonth = () => {
    let start = "";
    let end = "";

    if (value.startDate && value.endDate) {
      const isThisYearSelected = isRangeMatching("This Year");

      if (isThisYearSelected) {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();

        let prevMonth = currentDate.getMonth() - 1;
        let year = currentYear;

        if (prevMonth < 0) {
          prevMonth = 11;
          year = currentYear - 1;
        }

        const newStartDate = new Date(year, prevMonth, 1);
        start = datepipeModel.datetostring(newStartDate);

        const newEndDate = new Date(year, prevMonth + 1, 0);
        end = datepipeModel.datetostring(newEndDate);
      } else {
        let startDate = new Date(value.startDate);

        let newStartDate = new Date(startDate);
        newStartDate.setMonth(startDate.getMonth() - 1);
        newStartDate.setDate(1);

        let newEndDate = new Date(newStartDate);
        newEndDate.setMonth(newStartDate.getMonth() + 1);
        newEndDate.setDate(0);

        start = datepipeModel.datetostring(newStartDate);
        end = datepipeModel.datetostring(newEndDate);
      }
    }

    return { start, end };
  };

  const previousPeriod = () => {
    let start = "";
    let end = "";
    if (value.startDate && value.endDate) {
      let days = getDays(value.startDate, value.endDate) + 1;
      let d = new Date(value.startDate);
      d.setDate(d.getDate() - days);
      start = datepipeModel.datetostring(d);
      let ed = new Date(value.startDate);
      ed.setDate(ed.getDate() - 1);
      end = datepipeModel.datetostring(ed);
    }
    return { start, end };
  };

  const compareChange = (e) => {
    let start = "";
    let end = "";
    if (e == "Previous Period") {
      start = previousPeriod().start;
      end = previousPeriod().end;
    } else if (e == "Previous Year") {
      start = previousYear().start;
      end = previousYear().end;
    } else if (e == "Previous Month") {
      start = previousMonth().start;
      end = previousMonth().end;
    }

    let v = {
      ...value,
      compareStart: start,
      compareEnd: end,
      compare: e,
    };
    onChange({ ...v });
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setItemsOpen(false);

        setTimeout(() => {
          if (menuButtonRef.current?.contains(document.activeElement)) {
            menuButtonRef.current.blur();
          }
        }, 10);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const RandomNumber = Math.random(1000);

  const isRangeMatching = (rangeId) => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const startDate = value?.startDate || "";
    const endDate = value?.endDate || "";

    if (customButtons) {
      const days = parseInt(rangeId.split(' ')[0]);
      const today = new Date();
      const end = new Date(today);
      end.setDate(today.getDate() + days);
      return (
        startDate === datepipeModel.datetostring(today) &&
        endDate === datepipeModel.datetostring(end)
      );
    }

    switch (rangeId) {
      case "Last Month": {
        const lastMonthStart = new Date(year, month - 1, 1);
        const lastMonthEnd = new Date(year, month, 0);
        return (
          startDate === `${lastMonthStart.getFullYear()}-${String(lastMonthStart.getMonth() + 1).padStart(2, "0")}-01` &&
          endDate == moment(lastMonthEnd).format('YYYY-MM-DD')
        );
      }

      case "This Month": {
        const thisMonthStart = new Date(year, month, 1);
        const thisMonthEnd = new Date(year, month + 1, 0);
        return (
          startDate === moment(thisMonthStart).format('YYYY-MM-DD') &&
          endDate === moment(thisMonthEnd).format('YYYY-MM-DD')
        );
      }

      case "This Year": {
        const thisYearStart = `${year}-01-01`;
        const thisYearEnd = `${year}-12-31`;
        return startDate === thisYearStart && endDate === thisYearEnd;
      }

      case "Last Year": {
        const lastYearStart = `${year - 1}-01-01`;
        const lastYearEnd = `${year - 1}-12-31`;
        return startDate === lastYearStart && endDate === lastYearEnd;
      }

      case "all": {
        return !value?.startDate && !value?.endDate;
      }

      case "custom": {
        return !(
          isRangeMatching("This Month") ||
          isRangeMatching("Last Month") ||
          isRangeMatching("This Year") ||
          isRangeMatching("Last Year") ||
          isRangeMatching("all") ||
          (customButtons && (
            isRangeMatching("15 Days") ||
            isRangeMatching("30 Days") ||
            isRangeMatching("45 Days") ||
            isRangeMatching("90 Days")
          ))
        );
      }

      default:
        return false;
    }
  };

  return (
    <div ref={ref}>
      <Menu as='a' className={`relative list_box_active_state inline-block text-left ${fullWidth ? "w-full" : "w-fit"}`}>
        <MenuButton
          ref={menuButtonRef}
          data-open={ItemsOpen}
          disabled={disabled}
          data-tooltip-id={`tooltip${RandomNumber}`}
          className={`!px-4 w-full text-[#1D2433] !text-sm h-10 font-normal min-w-[240px] py-2.5 flex items-center justify-between gap-2 bg-[#fff]  rounded-extra_large !shadow-box border-shadow hover:bg-[#F3F2F5] transition-all focus:ring-2 ring-[#F1F2F3] disabled:bg-[#F3F2F5] disabled:cursor-not-allowed focus:!outline-[#115B9D] focus-visible:!outline-[#115B9D] focus-visible:!outline-1 focus:!outline-1 focus-visible:!outline focus:!outline focus-visible:border-indigo-500
             ${(value?.startDate && value?.endDate && !isFocusedData)
              ? "![outline-color:#6B25F9] ![outline-width:1px] ![outline-style:solid]"
              : ""
            } ${outerClass}`}
          onClick={e => setItemsOpen(!ItemsOpen)}
        >
          {!value?.startDate || !value?.endDate ? (
            <>{range == 'all' || (allTime || (!value.startDate && !value?.endDate)) ? allTimeText : placeholder || "Start Date - End Date"}</>
          ) : (
            <>
              {datepipeModel.date(value?.startDate, user?.companyDateFormat)} -{" "}
              {datepipeModel.date(value?.endDate, user?.companyDateFormat)}
            </>
          )}
          <IoIosArrowDown className={`h-[18px] text-bold w-5 text-[#75757A]`} />
        </MenuButton>
        {ItemsOpen && <MenuItems static className={`absolute ${outerClass ? outerClass : 'right-0'}  z-50 mt-2 min-w-[320px] origin-top-right divide-y divide-gray-100 rounded-large bg-white shadow-lg ring-1 ring-black/5 outline outline-[1px] !outline-[#115B9D] `} id="main_calender">

          <div className="!px-4 !py-3 ">
            <>
              {buttonShow ? null : <div className="grid grid-cols-2 !gap-3 !mb-3">
                {rangeList.map((itm, index) => {
                  return (
                    <button
                      key={index}
                      className={`!px-4 text-typo text-sm min-w-28 font-medium py-2.5 flex items-center justify-center gap-2 bg-[#fff] rounded-extra_large shadow-btn hover:bg-[#F3F2F5] border border-gray-5 transition-all focus:ring-2 ring-[#F1F2F3] disabled:bg-[#F3F2F5] disabled:cursor-not-allowed !outline-none ${isRangeMatching(itm?.id) && !CustomSelct ? '!bg-[#115B9D]  !border-[#115B9D] !text-white' : ""}`}
                      type="button"
                      disabled={disbaledDate ? itm?.name == 'This Month' || itm?.name == 'This Year' ? false : true : false}
                      onClick={(e) => { rangeClick(itm.id); setCustomSelect(false) }}>
                      {itm.name}
                    </button>
                  );
                })}
                {showcustom == true ? <button type="button"
                  className={`!px-4 text-typo text-sm min-w-28 font-medium py-2.5 flex items-center justify-center gap-2 bg-[#fff] rounded-extra_large shadow-btn hover:bg-[#F3F2F5] border border-[#D0D5DD] transition-all focus:ring-2 ring-[#F1F2F3] disabled:bg-[#F3F2F5] disabled:cursor-not-allowed !outline-none ${isRangeMatching("custom") || CustomSelct ? " !bg-[#115B9D]  !border-[#115B9D] !text-white" : ""}`}
                  onClick={(e) => { rangeClick("custom"); setCustomSelect(true) }}
                >
                  Custom
                </button> : null}
              </div>}
              <div className="">
                {(showcustom == false) && !buttonShow ? (
                  <></>
                ) : (
                  <>
                    {maxDate ?
                      <DateRange
                        editableDateInputs={true}
                        onChange={(e) => blockDateChange(e.selection, setItemsOpen)}
                        moveRangeOnFirstSelection={false}
                        ranges={getBlockValue()}
                        months={monthsCount}
                        direction="horizontal"
                        rangeColors={["#115B9D"]}
                        maxDate={maxDate}
                        shownDate={value?.startDate ? new Date(value?.startDate) : maxDate}
                      />
                      :
                      <>
                        {disbaledDate ? <DateRange
                          editableDateInputs={true}
                          onChange={(e) => blockDateChange(e.selection, setItemsOpen)}
                          moveRangeOnFirstSelection={false}
                          ranges={getBlockValue()}
                          minDate={new Date()}
                          months={monthsCount}
                          direction="horizontal"
                          rangeColors={["#115B9D"]}
                        /> : <DateRange
                          editableDateInputs={true}
                          onChange={(e) => blockDateChange(e.selection, setItemsOpen)}
                          moveRangeOnFirstSelection={false}
                          ranges={getBlockValue()}
                          months={monthsCount}
                          direction="horizontal"
                          rangeColors={["#115B9D"]}
                        />}
                      </>
                    }
                  </>
                )}
              </div>
              {isCompare ? (
                <>
                  <Menu as="div" className="relative w-fit block mx-auto ">
                    <MenuButton className="!px-4 text-typo text-sm h-10 font-medium py-2.5 flex items-center justify-center gap-2 bg-[#fff] rounded-large shadow-btn hover:bg-[#F3F2F5] border border-[#D0D5DD] transition-all focus:ring-2 ring-[#F1F2F3] disabled:bg-[#F3F2F5] disabled:cursor-not-allowed">
                      Compare
                      <TiArrowSortedDown className={`h-4 w-4 text-[#7E8B99]`} />
                    </MenuButton>
                    <MenuItems className="absolute right-0 z-50 mt-2 min-w-[320px] origin-top-right divide-y divide-gray-100 rounded-large bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
                      <div className="!px-4 !py-3 space-y-2">
                        <MenuItem>
                          <a className={`py-2 px-3.5 cursor-pointer hover:bg-gray-200  text-typo block rounded-large text-sm ${!value.compare ? "!bg-[#115B9D] !text-white font-medium hover:!text-white" : "hover:!text-typo"}`}
                            onClick={(e) => { compareChange(""); setItemsOpen(false) }}>
                            Reset Compare
                          </a>
                        </MenuItem>
                        <MenuItem>
                          <a className={`py-2 px-3.5 cursor-pointer hover:bg-gray-200  text-typo block rounded-large text-sm ${value.compare == "Previous Month" ? "!bg-[#115B9D] !text-white font-medium hover:!text-white" : "hover:!text-typo"}`}
                            onClick={(e) => { compareChange("Previous Month"); setItemsOpen(false); }}>
                            Previous Month (
                            {datepipeModel.date(
                              previousMonth().start,
                              user.companyDateFormat
                            )}
                            {" "}-{" "}
                            {datepipeModel.date(
                              previousMonth().end,
                              user.companyDateFormat
                            )}
                            )
                          </a>
                        </MenuItem>
                        <MenuItem>
                          <a className={`py-2 px-3.5 cursor-pointer hover:bg-gray-200  text-typo block rounded-large text-sm ${value.compare == "Previous Year" ? "!bg-[#115B9D] !text-white font-medium hover:!text-white" : "hover:!text-typo"}`}
                            onClick={(e) => { compareChange("Previous Year"); setItemsOpen(false) }}>
                            Same Period Last Year (
                            {datepipeModel.date(
                              previousYear().start,
                              user.companyDateFormat
                            )}
                            {" "}-{" "}
                            {datepipeModel.date(
                              previousYear().end,
                              user.companyDateFormat
                            )}
                            )
                          </a>
                        </MenuItem>
                        <MenuItem>
                          <a className={`py-2 px-3.5 cursor-pointer hover:bg-gray-200  text-typo block rounded-large text-sm ${value.compare == "Previous Period" ? "!bg-[#115B9D] !text-white font-medium hover:!text-white" : "hover:!text-typo"}`}
                            onClick={(e) => { compareChange("Previous Period"); setItemsOpen(false) }}>
                            Previous Period(Custom Dates) (
                            {datepipeModel.date(
                              previousPeriod().start,
                              user.companyDateFormat
                            )}
                            {" "}-{" "}
                            {datepipeModel.date(
                              previousPeriod().end,
                              user.companyDateFormat
                            )}
                            )
                          </a>
                        </MenuItem>
                      </div>
                    </MenuItems>
                  </Menu>
                </>
              ) : (
                <></>
              )}
            </>
          </div>
        </MenuItems>}
      </Menu>
      {title ? <>
        <Tooltip
          id={`tooltip${RandomNumber}`}
          classNameArrow="!border-b-[1.5px] !border-r-[1.5px] border-[#115B9D] !rounded-[2px]"
          className="z-[999] !opacity-100 !shadow-box border !border-grey border border-[#115B9D] !rounded-large !text-center !max-w-[250px] p-2"
          place="bottom"><div className="tooltipCal">{title}</div></Tooltip>
      </> : <></>}
      <div
        className={`dropdownOverlap ${toggle ? "d-block" : ""}`}
        onClick={(e) => toggleChange(false)} />
    </div>
  )
};
export default DateRangePicker